import { computed } from 'vue'
import { useStore } from '../store/index'
import { t } from './solicitudTextos'

/**
 * WhatsApp de la notaría para el encargo online: el que tiene configurado el chat social de la web
 * (NOTARIA.SocialChat.Agentes con app "whatsapp"). Si no hay ninguno, no se muestra nada.
 */
export function useWhatsappNotaria() {
  const store = useStore()
  const numero = computed<string>(() => {
    const agentes: any[] = (store.NOTARIA as any)?.SocialChat?.Agentes ?? []
    const a = agentes.find((x) => String(x?.app ?? '').toLowerCase() === 'whatsapp' && (x?.number || x?.href))
    if (!a) return ''
    const desdeHref = String(a.href ?? '').match(/wa\.me\/(\d+)/)?.[1] ?? ''
    let n = String(a.number || desdeHref).replace(/\D/g, '')
    if (n.length === 9) n = '34' + n // número español sin prefijo
    return n.length >= 10 ? n : ''
  })
  const cfg = computed<any>(() => (store.NOTARIA as any)?.SolicitudWeb ?? null)
  /** Hay WhatsApp en la web y la notaría no lo ha ocultado en la configuración del encargo. */
  const activo = computed(() => !!numero.value && cfg.value?.MostrarWhatsapp !== false)
  /** Textos configurables en el panel (Encargo online → WhatsApp); vacíos = los predeterminados, traducidos. */
  const pregunta = computed(() => String(cfg.value?.WhatsappPregunta ?? '').trim() || t('¿Tiene dudas con el formulario?'))
  const texto = computed(() => String(cfg.value?.WhatsappTexto ?? '').trim() || t('Escríbanos por WhatsApp'))
  /** Mensaje que se abre escrito: el de la notaría o el predeterminado. {ref} se cambia por la referencia. */
  function mensaje(predeterminado: string, ref = '') {
    const m = String(cfg.value?.WhatsappMensaje ?? '').trim()
    return m ? m.replace(/\{ref\}/g, ref) : predeterminado
  }
  /** Enlace que abre WhatsApp con el mensaje ya escrito. */
  function enlace(texto: string) {
    return numero.value ? `https://wa.me/${numero.value}?text=${encodeURIComponent(texto)}` : ''
  }
  /** Número legible para mostrarlo (p. ej. en el cartel QR). */
  const numeroVisible = computed(() => {
    const n = numero.value
    if (!n) return ''
    if (n.startsWith('34') && n.length === 11) return `${n.slice(2, 5)} ${n.slice(5, 8)} ${n.slice(8)}`
    return '+' + n
  })
  return { numero, numeroVisible, enlace, activo, pregunta, texto, mensaje }
}
